import Axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { setCloudflareWorkerReverseProxyInstance } from '@linkie/api-client';
import toastClient from './toast-client';
import { clearStaleAuth } from '../utils/clear-auth';
import { buildLoginRedirectUrl } from '../utils/auth-redirect';

function requestInterceptor(config: InternalAxiosRequestConfig) {
  if (config.headers) {
    config.headers.Accept = 'application/json';
  }

  return config;
}

export const cloudflareWorkerReverseProxy = Axios.create({
  baseURL: process.env.CLOUDFLARE_WORKER_REVERSE_PROXY_HOST,
});

cloudflareWorkerReverseProxy.interceptors.request.use(requestInterceptor);
cloudflareWorkerReverseProxy.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data;
  },
  (error) => {
    const message = error.response?.data?.message || error.message;
    toastClient.error(message);

    if (error.response?.status === 401) {
      void clearStaleAuth().finally(() => {
        if (window.location.pathname !== '/auth/login') {
          window.location.href = buildLoginRedirectUrl(window.location.pathname + window.location.search);
        }
      });
    }

    return Promise.reject(error);
  },
);

setCloudflareWorkerReverseProxyInstance(cloudflareWorkerReverseProxy);
